module.exports = __webpack_public_path__ + "img/campanha-gripe.b3fd84e0.png";